import React from 'react';
import dynamic from 'next/dynamic';

const Comments = dynamic(() => import('./index'), {
  ssr: false,
});

const DynamicallyLoadedComments = (props) => <Comments {...props} />;

export default DynamicallyLoadedComments;
